export default __webpack_public_path__ + "static/media/Face.6ff758b4.jpg";